import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../data/notification";
import useT from "../../i18n/useT";

const Permissions = () => {
    const t = useT();
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.user.language);
    const role = useSelector((state) => state.user.role);
    const isAdmin = role === "admin";

    const [data, setData] = useState(null);

    const notify = (text, type) => {
        dispatch(notificationActions.changeNotification({ show: true, text, type }));
        setTimeout(() => dispatch(notificationActions.changeNotification({ show: false, text: "", type: "" })), 4000);
    };

    useEffect(() => {
        if (!isAdmin) return;
        axios.get("/api/permissions").then((res) => setData(res.data.data)).catch(() => {});
    }, [isAdmin]);

    if (!isAdmin) {
        return <div className="page-content-main-container"><h2 className="page-title">{t("perm.title")}</h2></div>;
    }

    const toggle = (role, capability, next) => {
        // optimistic
        setData((d) => ({ ...d, matrix: { ...d.matrix, [role]: { ...d.matrix[role], [capability]: next } } }));
        axios.put("/api/permissions", { role, capability, allowed: next })
            .then((res) => notify(res.data.message.en, "success-notification"))
            .catch((err) => {
                notify(err.response?.data?.message?.en || "Error", "error-notification");
                setData((d) => ({ ...d, matrix: { ...d.matrix, [role]: { ...d.matrix[role], [capability]: !next } } }));
            });
    };

    const capLabel = (c) => (c.labels && (c.labels[lang] || c.labels.en)) || c.key;

    return (
        <div className="page-content-main-container">
            <h2 className="page-title">{t("perm.title")}</h2>
            <div style={{ fontSize: "13px", opacity: 0.7, marginBottom: "16px" }}>{t("perm.hint")}</div>

            {data && (
                <div style={{ overflowX: "auto" }}>
                    <table className="table" style={{ width: "100%" }}>
                        <thead>
                            <tr>
                                <th>{t("perm.capability")}</th>
                                <th style={{ textAlign: "center" }}>Admin</th>
                                {data.roles.map((r) => <th key={r} style={{ textAlign: "center" }}>{t(`perm.role_${r}`) || r}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {data.capabilities.map((c) => (
                                <tr key={c.key}>
                                    <td><div>{capLabel(c)}</div><code style={{ fontSize: "11px", opacity: 0.55 }}>{c.key}</code></td>
                                    <td style={{ textAlign: "center" }}><input type="checkbox" checked readOnly disabled /></td>
                                    {data.roles.map((r) => (
                                        <td key={r} style={{ textAlign: "center" }}>
                                            <input type="checkbox" checked={!!data.matrix[r][c.key]} onChange={(e) => toggle(r, c.key, e.target.checked)} />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Permissions;
